import React from 'react';
import { TRANSLATIONS } from '../../translations';
import BetaIcon, { IconSizes } from '../component/Icons/Icon';
import { ORDER_ACTIONS } from '../define/constants';

export const getRequestType = (status, suffix = null) => {
  let requestType = null;
  if (status.includes('confirmed')) {
    requestType = 'confirmed_booking';
  }
  if (status.includes('on_hold')) {
    requestType = 'onhold';
  }

  return suffix ? `${requestType}_${suffix}` : requestType;
};

export const getActionlist = (order) => {
  const orderItems = order?.items || [];

  const allowedOperations =
    order && order.customerAllowedOperations
      ? order.customerAllowedOperations
      : [];

  let blockReschedule = false;

  for (let i = 0; i < orderItems.length; i++) {
    if (orderItems[i].priceSelector === undefined) {
      blockReschedule = true;
      break;
    }
  }

  const actions = {};

  for (const operation of allowedOperations) {
    switch (operation) {
      case !blockReschedule && ORDER_ACTIONS.COMPLETED_BOOKING_NEW_DATE:
      case !blockReschedule && ORDER_ACTIONS.ONHOLD_NEW_DATE:
      case !blockReschedule && ORDER_ACTIONS.CONFIRMED_BOOKING_NEW_DATE:
        actions.reschedule = {
          title: TRANSLATIONS.RESCHEDULE_YOUR_ADVENTURE,
          description:
            TRANSLATIONS.CHOOSE_A_NEW_DATE_BASED_ON_YOUR_AVAILABILITY,
          icon: <BetaIcon name="changeDate" size={IconSizes[24]} />,
        };
        break;
      case ORDER_ACTIONS.COMPLETED_BOOKING_TO_VOUCHER:
      case ORDER_ACTIONS.ONHOLD_TO_VOUCHER:
      case ORDER_ACTIONS.CONFIRMED_BOOKING_TO_VOUCHER:
        actions.transformToVoucher = {
          title: TRANSLATIONS.GET_A_VOUCHER,
          description:
            TRANSLATIONS.WANT_TO_RESCHEDULE_CONVERT_YOUR_BOOKING_INTO_A_VOUCHER,
          icon: <BetaIcon name="ticket" size={IconSizes[24]} />,
        };
        break;
      case ORDER_ACTIONS.ONHOLD_TO_GIFTCARD:
      case ORDER_ACTIONS.CONFIRMED_BOOKING_TO_GIFTCARD:
        actions.transformToGiftcard = {
          title: TRANSLATIONS.GET_A_GIFT_CARD,
          description:
            TRANSLATIONS.CONVERT_YOUR_BOOKING_INTO_A_GIFT_CARD_VALID_18_MONTHS,
          icon: <BetaIcon name="giftcard" size={IconSizes[24]} />,
        };
        break;
      case ORDER_ACTIONS.COMPLETED_BOOKING_REFUND:
      case ORDER_ACTIONS.ONHOLD_REFUND:
        actions.refund = {
          title: TRANSLATIONS.REQUEST_REFUND,
          description:
            TRANSLATIONS.WOULD_YOU_PREFER_THE_MONEY_BACK_PROCEED_WITH_THE_REFUND,
          icon: <BetaIcon name="refund" size={IconSizes[24]} />,
        };
        break;
      case ORDER_ACTIONS.CONFIRMED_BOOKING_REFUND:
        actions.refund = {
          title: TRANSLATIONS.REQUEST_REFUND,
          description: TRANSLATIONS.CANCELLATION_POLICIES_APPLIED,
          icon: <BetaIcon name="refund" size={IconSizes[24]} />,
        };
        break;
      default:
        break;
    }
  }

  return actions;
};

export const calculatePriceDifference = (price, orderItems) => {
  const priceId = price.id;
  const priceObject = price.price;
  const priceType = price.type;

  let priceDifference = 0;

  for (let i = 0; i < orderItems.length; i++) {
    if (orderItems[i].priceId === priceId) continue;
    if (priceType === 'top3' || priceType === 'top') {
      const priceSelector = orderItems[i].priceSelector;
      const quantity = orderItems[i].quantity;
      const price = orderItems[i].price;
      const newPrice = quantity * priceObject[priceSelector];

      priceDifference += newPrice - price;
    } else if (priceType === 'variable') {
      const quantity = orderItems[i].quantity;
      const price = orderItems[i].price;
      const newPrice = quantity * priceObject[quantity];

      priceDifference += newPrice - price;
    } else if (priceType === 'group') {
      const price = orderItems[i].price;
      const newPrice = priceObject;

      priceDifference += newPrice - price;
    } else if (priceType === 'fixed') {
      const quantity = orderItems[i].quantity;
      const price = orderItems[i].price;
      const newPrice = quantity * priceObject;

      priceDifference += newPrice - price;
    }
  }

  return priceDifference;
};
